import { createFileRoute } from '@tanstack/react-router'

import { SupportPage } from '@/pages/support-page'

export const Route = createFileRoute('/_dashboard/support')({
    component: SupportPage,
    onEnter: () => {
        document.title = 'Taxoparkee - Помощь'
    },
})
